import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from 'clicklease-ui-elements';

@Component({
    selector: 'rose-portal-card-title-component',
    standalone: true,
    templateUrl: './card-title.component.html',
    styleUrl: './card-title.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardTitleComponent extends BaseComponent {
    /**
     * @public
     * @readonly
     * @description This required input contains the title to display.
     * @alias card-title
     */
    public readonly title = input.required<string>({ alias: 'card-title' });

    /**
     * @public
     * @readonly
     * @description This required input contains the subtitle to display.
     * @alias card-subtitle
     */
    public readonly subtitle = input.required<string>({ alias: 'card-subtitle' });
}